/* Release flags — controls which Control Center modules are visible in the UI.
   Modules whose flag is false are hidden from navigation and redirect to the
   dashboard if accessed directly. Backend code, APIs, and permissions are
   unaffected by these flags.

   To enable a module in a future release: set its flag to true and rebuild.
   No other code changes are required. */
export const RELEASE_FLAGS = {
  API_KEYS: false,
  PARTNERS: false,
};
